<template>
    <v-container>
        <v-card slot="rightContainer" outlined>
            <v-card-title class="grey lighten-4">
                <b>PLANTILLAS DE EQUIPAMIENTO</b>
                <v-spacer />
                <v-col cols="12" sm="3">
                    <v-autocomplete
                        v-model="filtroTipo"
                        :items="tiposUnicos"
                        label="FILTRAR POR TIPO"
                        clearable
                        dense
                        hide-details
                    />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                        dense
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="BUSCAR"
                        single-line
                        hide-details
                    />
                </v-col>
                <v-col cols="12" sm="2">
                    <v-btn
                        color="primary"
                        block
                        :to="'/logistica/equipamiento/plantillas/crear'"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        NUEVA PLANTILLA
                    </v-btn>
                </v-col>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table
                            multi-sort
                            :search="search"
                            :items="plantillasFiltradas"
                            :headers="headers"
                            class="elevation-1"
                            :items-per-page="20"
                        >
                            <template v-slot:[`item.items`]="{ item }">
                                <v-chip small color="grey lighten-2">
                                    {{ item.itemsCount }} items
                                </v-chip>
                            </template>
                            <template v-slot:[`item.activo`]="{ item }">
                                <v-chip
                                    small
                                    :color="item.activo ? 'green' : 'red'"
                                    dark
                                    class="white--text font-weight-bold"
                                >
                                    {{ item.activo ? 'ACTIVO' : 'INACTIVO' }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            color="primary"
                                            small
                                            @click="editarPlantilla(item)"
                                        >
                                            mdi-pencil
                                        </v-icon>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            color="red"
                                            small
                                            @click="confirmarEliminar(item)"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            search: '',
            filtroTipo: null,
            loadingLista: false,
            listaPlantillas: [],
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Tipo', value: 'tipo' },
                { text: 'Descripción', value: 'descripcion' },
                { text: 'Items', value: 'itemsCount', sortable: false },
                { text: 'Activo', value: 'activo' },
                { text: 'Acciones', value: 'action', sortable: false }
            ]
        }
    },
    computed: {
        tiposUnicos() {
            const tipos = [...new Set(this.listaPlantillas.map((p) => p.tipo))]
            return tipos
        },
        plantillasFiltradas() {
            let lista = this.listaPlantillas.map((p) => {
                let items = p.items || []
                if (typeof items === 'string') {
                    try {
                        // Primer parse: quita las comillas externas
                        let parsed = JSON.parse(items)
                        // Si sigue siendo string (doble escape), parsear de nuevo
                        if (typeof parsed === 'string') {
                            parsed = JSON.parse(parsed)
                        }
                        items = Array.isArray(parsed) ? parsed : []
                    } catch (e) {
                        items = []
                    }
                }
                return { ...p, itemsCount: items.length }
            })
            if (this.filtroTipo) {
                lista = lista.filter((p) => p.tipo === this.filtroTipo)
            }
            return lista
        }
    },
    methods: {
        async getLista() {
            this.loadingLista = true
            try {
                const response = await this.$store.dispatch('inventario/getPlantillas')
                if (response && response.codigoRespuesta === '00') {
                    this.listaPlantillas = response.data || []
                } else {
                    this.listaPlantillas = []
                }
            } catch (error) {
                console.error('Error cargando plantillas:', error)
                this.listaPlantillas = []
            }
            this.loadingLista = false
        },
        editarPlantilla(item) {
            this.$router.push(`/logistica/equipamiento/plantillas/editar/${item.id}`)
        },
        confirmarEliminar(item) {
            if (!confirm(`¿Estás seguro de eliminar la plantilla "${item.tipo}"? Esta acción no se puede deshacer.`)) {
                return
            }
            this.eliminarPlantilla(item)
        },
        async eliminarPlantilla(item) {
            try {
                await this.$store.dispatch('inventario/eliminarPlantilla', item.id)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'Plantilla eliminada correctamente',
                    color: 'success',
                    timeout: 2000
                })
                await this.getLista()
            } catch (error) {
                console.error('Error eliminando plantilla:', error)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'No se pudo eliminar la plantilla',
                    color: 'error',
                    timeout: 3000
                })
            }
        }
    },
    async mounted() {
        await this.getLista()
    }
}
</script>
